import { configureStore, Reducer, combineReducers, Slice } from '@reduxjs/toolkit';
import AuthSlice from 'features/Auth/Slices/auth';

interface ISimpleMap {
	[field: string]: Reducer;
}
const reducerMap: ISimpleMap = { [AuthSlice.name]: AuthSlice.reducer };

const store = configureStore({
	reducer: combineReducers(reducerMap),
});

export const registerSlice = (slice: Slice): void => {
	reducerMap[slice.name] = slice.reducer;
	store.replaceReducer(combineReducers(reducerMap));
};

export default store;
